// extracted by mini-css-extract-plugin
export default {"scrollContainer":"TableValuesWrapper_scrollContainer__d8219","gridContainer":"TableValuesWrapper_gridContainer__Cr2-K"};